import React, { useState, useCallback, useMemo } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Modal, Button, Form } from "antd";
import { connect } from "dva";
import { STATUS } from "@/utils/enum";
import PickupDropoffForm from "@/components/PickupDropoffForm/PickupDropoffForm";

const RemovePickupDropoffModal = ({ loadId, onSuccess, type, configPerm }) => {
  const [formRef] = Form.useForm();
  const [status, setStatus] = useState(STATUS.IDLE);
  const [visible, setVisible] = useState(false);

  const handleClick = useCallback(() => {
    setVisible(true);
  }, []);

  const handleCancel = useCallback(() => {
    formRef?.resetFields();
    setVisible(false);
  }, [formRef]);

  const canRemove = useMemo(() => configPerm["CoreService.AdminShipments.RemoveLeg"], [configPerm]);

  const buttonStyle = {
    marginRight: "8px",
    transition: "all 0.3s ease",
  };

  return (
    <section style={{ marginLeft: 8 }}>
      {canRemove && (
        <Button
          type="primary"
          danger
          onClick={handleClick}
          icon={<DeleteOutlined />}
          style={buttonStyle}
          size="small"
          className="hover-effect"
        >
          Remove
        </Button>
      )}
      <Modal
        open={visible}
        title={`Are you sure you want to remove the ${type}?`}
        onCancel={handleCancel}
        onOk={formRef.submit}
        loading={status === STATUS.LOADING}
      >
        <PickupDropoffForm formRef={formRef} type={type} onSuccess={onSuccess} loadId={loadId} setStatus={setStatus} />
      </Modal>
    </section>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs?.configPerm,
}))(RemovePickupDropoffModal);
